import { render, staticRenderFns } from "./RepuSideBarNew.vue?vue&type=template&id=223f2d33&scoped=true"
import script from "./RepuSideBarNew.vue?vue&type=script&lang=js"
export * from "./RepuSideBarNew.vue?vue&type=script&lang=js"
import style0 from "./RepuSideBarNew.vue?vue&type=style&index=0&id=223f2d33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f2d33",
  null
  
)

export default component.exports